import {
  ITINERARY_LIST_LOADING,
  GET_ITINERARY_LIST,
  GET_ITINERARY_LIST_ERROR,
  GET_ITINERARY_BY_ID_LOADING,
  GET_ITINERARY_BY_ID_SUCCESS,
  GET_ITINERARY_BY_ID_ERROR,
  DELETEING_ITINERARY,
  DELETE_ITINERARY,
  DELETE_ITINERARY_ERROR,
  DELETED_ITINERARY_LIST_LOADING,
  GET_DELETED_ITINERARY_LIST,
  GET_DELETED_ITINERARY_LIST_ERROR,
  RESTORE_ITINERARY_LIST_LOADING,
  RESTORE_ITINERARY_LIST,
  RESTORE_ITINERARY_LIST_ERROR,   
  PERMA_DELETE_ITINERARY,
  PERMA_DELETE_ITINERARY_ERROR,
  PERMA_DELETEING_ITINERARY,
  
} from "./types";
import axios from "axios";
import { BASE_URL } from "../urls";
import { message } from "antd";

export const getList = (tokenData) => async (dispatch) => {
  dispatch({
    type: ITINERARY_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/travel/itinerary/active`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_ITINERARY_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_ITINERARY_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const getEntityById = (tokenData, id) => async (dispatch) => {
  dispatch({
    type: GET_ITINERARY_BY_ID_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/travel/itinerary/active/${id}`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_ITINERARY_BY_ID_SUCCESS,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_ITINERARY_BY_ID_ERROR,
        payload: error.response,
      });
    });
};

export const getDeletedList = (tokenData) => async (dispatch) => {
  dispatch({
    type: DELETED_ITINERARY_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/travel/itinerary/deleted`, {
      headers: {
        'Authorization': `${tokenData.token_type} ${tokenData.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: GET_DELETED_ITINERARY_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_DELETED_ITINERARY_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const deleteEntityById = (idList) => async (dispatch) => {
  dispatch({
    type: DELETEING_ITINERARY,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/travel/itinerary/bulk/delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: DELETE_ITINERARY,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: DELETE_ITINERARY_ERROR,
        payload: error.response,
      });
    });
};

export const permanentDeleteEntity = (idList) => async (dispatch) => {
  dispatch({
    type: PERMA_DELETEING_ITINERARY,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/travel/itinerary/bulk/perma-delete`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: PERMA_DELETE_ITINERARY,
        payload: response,
      })      
      message.success(response.data.message);
    })
    .catch(function (error) {
      dispatch({
        type: PERMA_DELETE_ITINERARY_ERROR,
        payload: error.response,
      })      
      message.error(error.response.data.message);
    });
};

export const restoretDeleteEntity = (idList, history) => async (dispatch) => {
  dispatch({
    type: RESTORE_ITINERARY_LIST_LOADING,
  });
  let bulk = {bulk: idList}
  await axios
    .post(`${BASE_URL}api/v1/admin/travel/itinerary/bulk/restore`, bulk, {
      headers: {
        'Authorization': `${localStorage.token_type} ${localStorage.access_token}`
      }
    })
    .then(function (response) {
      dispatch({
        type: RESTORE_ITINERARY_LIST,
        payload: response,
      });      
      message.success(response.data.message);
        history.push("/packages")
    })
    .catch(function (error) {
      dispatch({
        type: RESTORE_ITINERARY_LIST_ERROR,
        payload: error.response,
      })     
      message.error(error.response.data.message);
    });
};



